import React, { Component } from "react";
import "./preferences-landing.styles.scss";

import { ReactComponent as SlotImage } from "../../assets/auctionslot.svg";
import { ReactComponent as PreferencesImage } from "../../assets/preferences.svg";

import AuctionPreferences from "../system-parameters/system-parameters.page";

import { Dispatch } from "redux";
import { Tabs } from "antd";
import SlotTabs from "../slot-tabs/slot-tabs.page";
import { connect } from "react-redux";
import { selectViewAuctionPage } from "../../redux/common/common.selectors";
import { setViewAuctionPage } from "../../redux/common/common.actions";
import { createStructuredSelector } from "reselect";
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory,
  useLocation,
  Redirect,
} from "react-router-dom";

const { TabPane } = Tabs;

const PreferencesLanding: React.FC = (props: any) => {
  const { setViewAuctionPage, selectedKey } = props;
  const { url, path } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  return (
    <div className="preferences-landing">
      <Tabs
        // defaultActiveKey={
        //   sessionStorage.getItem("preferencesPage") || selectedKey
        // }
        activeKey={location.pathname}
        onChange={(activeKey) => {
          setViewAuctionPage(activeKey);
          sessionStorage.setItem("preferencesPage", activeKey);
          history.push(activeKey);
        }}
      >
        <TabPane tab={"Auction Slots"} key={`${url}/auctionslots`}></TabPane>
        <TabPane
          tab={"Auction Preferences"}
          key={`${url}/auctionpreferences`}
        ></TabPane>
      </Tabs>
      <Switch>
        <Route path={`${path}/auctionslots`}>
          <SlotTabs />
        </Route>
        <Route path={`${path}/auctionpreferences`}>
          <AuctionPreferences />
        </Route>
        <Redirect from={path} to={`${path}/auctionslots`} />
      </Switch>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectedKey: selectViewAuctionPage,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setViewAuctionPage: (activeKey: string) =>
      dispatch(setViewAuctionPage(activeKey)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreferencesLanding);
